// extracted by mini-css-extract-plugin
export default {"appealsList__title":"LkmAppealDetail_appealsList__title__CNdBN","appealsList":"LkmAppealDetail_appealsList__jwrRk","backButton":"LkmAppealDetail_backButton__G+GoA"};